var _ellipse, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 20,
    viewBox: "0 0 6 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.30769,
    cy: 2.51686,
    rx: 2.30769,
    ry: 2.51686,
    transform: "matrix(0 -1 -1 0 5.03369 20)",
    fill: "#9F9F9E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.30769,
    cy: 2.51686,
    rx: 2.30769,
    ry: 2.51686,
    transform: "matrix(0 -1 -1 0 5.03369 12.3077)",
    fill: "#9F9F9E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.30769,
    cy: 2.51686,
    rx: 2.30769,
    ry: 2.51686,
    transform: "matrix(0 -1 -1 0 5.03369 4.61537)",
    fill: "#9F9F9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMor);
export default __webpack_public_path__ + "static/media/mor.ed66fbad4a456c8e2803b0f492cc2100.svg";
export { ForwardRef as ReactComponent };